"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clientAuth = require("@devsta/client-auth");

var _getAlias = _interopRequireDefault(require("@devsta/get-alias"));

var _uiKit = require("@devsta/ui-kit");

var _login = _interopRequireDefault(require("../../../api/login"));

var _FormHeader = _interopRequireDefault(require("../../FormHeader"));

var _SetPasswordForm = _interopRequireDefault(require("../../SetPasswordForm"));

require("../styles/_set-password.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SetPassword = /*#__PURE__*/function (_Component) {
  _inherits(SetPassword, _Component);

  function SetPassword() {
    var _this;

    _classCallCheck(this, SetPassword);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SetPassword).call(this));

    _defineProperty(_assertThisInitialized(_this), "getErrorState", function (result, originalCredentials) {
      if (!result.errors) {
        return null;
      }

      var userObj = originalCredentials.user;

      _clientAuth.authLocalStore.save(_objectSpread({}, originalCredentials, {
        user: userObj
      }));

      return {
        error: result.errors ? result.errors[0].message : '',
        saving: false
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(password) {
        var _this$props, apolloClient, user, goToNextWizardStage, tempToken, createUser, onUpdateUser, organisationId, onLogin, originalCredentials, userObj, result, errorState;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, apolloClient = _this$props.apolloClient, user = _this$props.user, goToNextWizardStage = _this$props.goToNextWizardStage, tempToken = _this$props.tempToken, createUser = _this$props.createUser, onUpdateUser = _this$props.onUpdateUser, organisationId = _this$props.organisationId, onLogin = _this$props.onLogin;

                _this.setState({
                  saving: true
                });

                originalCredentials = _clientAuth.credentials.get();
                userObj = originalCredentials.user;

                _clientAuth.authLocalStore.save(_objectSpread({}, originalCredentials, {
                  user: userObj,
                  token: tempToken
                }));

                _context.prev = 5;
                _context.next = 8;
                return createUser({
                  email: user.email,
                  password: password,
                  organisationId: organisationId
                });

              case 8:
                result = _context.sent;
                _context.next = 11;
                return onUpdateUser({
                  changes: {}
                })(apolloClient, result);

              case 11:
                errorState = _this.getErrorState(result, originalCredentials);

                if (!errorState) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("return", void _this.setState(errorState));

              case 14:
                _context.next = 16;
                return (0, _login.default)({
                  email: user.email,
                  password: password,
                  alias: (0, _getAlias.default)()
                }, apolloClient, onLogin);

              case 16:
                if (goToNextWizardStage) {
                  goToNextWizardStage();
                }

                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](5);

                _this.setState(_this.getErrorState({
                  errors: [_context.t0]
                }, originalCredentials));

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 19]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _this.state = {
      error: void 0,
      saving: false
    };
    return _this;
  }

  _createClass(SetPassword, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          saving = _this$state.saving,
          error = _this$state.error;
      return _react.default.createElement("div", {
        className: "set-password"
      }, _react.default.createElement(_FormHeader.default, {
        title: "Set up your account"
      }), _react.default.createElement(_uiKit.Text, {
        heading3: true,
        className: "set-password__header"
      }, "Create Password"), _react.default.createElement(_SetPasswordForm.default, {
        onSubmit: this.onSubmit,
        buttonText: "Create Account",
        saving: saving
      }), _react.default.createElement(_uiKit.Text, {
        className: "set-password__terms"
      }, "By clicking 'Create Account' you agree to the Terms of Service and Privacy Policy as set with Shootsta HUB."), error ? _react.default.createElement("div", {
        className: "set-password__error"
      }, _react.default.createElement(_uiKit.Icon, {
        name: "alert",
        color: "thunderBird",
        size: 15
      }), _react.default.createElement(_uiKit.Text, {
        danger: true,
        className: "set-password__error__text"
      }, "Your request failed please try again")) : null);
    }
  }]);

  return SetPassword;
}(_react.Component);

exports.default = SetPassword;